// extracted by mini-css-extract-plugin
export default {"copyMetadataArtwork":"f7bLE_eHJtAwrQX_Qw4E"};